import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as DocumentRelatedAddSvg } from '../../assets/document-related-add-icon.svg';

export const DocumentRelatedAddIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={DocumentRelatedAddSvg} {...props} />;
};
